import React from 'react';
import './CardAction.css';

const CardAction = () => {

  const tarjetas = [
    {
      id: 1,
      titulo: 'Pagos Online',
      link: 'https://www.bancolombia.com/pagos/multipagos-pse',
      icon: (
        <svg viewBox="0 0 140 120" className="card-icon" fill="currentColor">
          <rect x="10" y="10" width="120" height="28" rx="8" />
          <rect x="10" y="48" width="120" height="62" rx="10" />
          <rect x="25" y="72" width="22" height="18" rx="4" fill="#ffffff" />
          <rect x="54" y="72" width="40" height="18" rx="4" fill="#ffffff" />
        </svg>
      )
    },
    {
      id: 2,
      titulo: 'Preinscripción gratuita Programas Técnicos',
      link: 'https://site3.q10.com/Preinscripcion?aplentId=f7bb9af6-4333-4e98-983c-cef7025ecc99',
      icon: (
        <svg viewBox="0 0 120 130" className="card-icon" fill="currentColor">
          <path d="M 60 10 A 12 12 0 0 1 60 34 A 12 12 0 0 1 60 10 Z" />
          <rect x="15" y="24" width="90" height="96" rx="14" />
          <circle cx="38" cy="52" r="4.5" fill="#ffffff" />
          <rect x="49" y="49" width="38" height="6" rx="3" fill="#ffffff" />
          <circle cx="38" cy="72" r="4.5" fill="#ffffff" />
          <rect x="49" y="69" width="38" height="6" rx="3" fill="#ffffff" />
          <circle cx="38" cy="92" r="4.5" fill="#ffffff" />
          <rect x="49" y="89" width="38" height="6" rx="3" fill="#ffffff" />
        </svg>
      )
    },
    {
      id: 3,
      titulo: 'Resolución y Licencia de Costos Educativos',
      link: 'https://drive.google.com/file/d/10SNLjgB0D6C33qYZNgaxbtEur9tIoYRG/view?usp=drive_link',
      icon: (
        <svg viewBox="0 0 120 130" className="card-icon" fill="currentColor">
          <path d="M 20 10 L 82 10 L 102 32 L 102 118 Q 102 122 98 122 L 20 122 Q 16 122 16 118 L 16 14 Q 16 10 20 10 Z" />
          <path d="M 80 10 L 80 32 L 102 32 Z" fill="#ffffff" opacity="0.8" />
          <rect x="38" y="55" width="44" height="7" rx="3.5" fill="#ffffff" />
          <rect x="38" y="72" width="44" height="7" rx="3.5" fill="#ffffff" />
          <rect x="38" y="89" width="44" height="7" rx="3.5" fill="#ffffff" />
        </svg>
      )
    }
  ];

  return (
    <section className="tarjetas-container">
      <div className="tarjetas-grid">
        {tarjetas.map((tarjeta) => (
          <a 
            key={tarjeta.id} 
            href={tarjeta.link} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="tarjeta-card"
          >
            <div className="icon-wrapper">
              {tarjeta.icon}
            </div>
            <h3 className="tarjeta-titulo">{tarjeta.titulo}</h3>
          </a>
        ))}
      </div>
    </section>
  );
};

export default CardAction;
